/**
 * formatNumber — Rounds to max 2 decimal places, removes trailing zeros.
 *
 * Examples: 1.5 → "1.5", 1.00 → "1", 1.126 → "1.13", 200 → "200"
 *
 * Special cases:
 * - value = 0 → "0"
 * - value < 0.01 and > 0 → "< 0.01"
 * - unit "Stück" → always integer (Math.ceil)
 * - unit "Prise" → no number, just "Prise"
 */

export function formatNumber(value: number, unit?: string): string {
  if (unit?.toLowerCase() === 'prise') return 'Prise';
  if (unit?.toLowerCase() === 'stück' || unit?.toLowerCase() === 'stueck') {
    return String(Math.ceil(value));
  }

  if (value === 0) return '0';
  if (value > 0 && value < 0.01) return '< 0.01';

  const rounded = Math.round(value * 100) / 100;
  return rounded % 1 === 0
    ? rounded.toFixed(0)
    : parseFloat(rounded.toFixed(2)).toString();
}

/**
 * Shorthand for rounding numbers in JSX without string conversion.
 * Returns the rounded number (not string).
 */
export function round2(value: number): number {
  return Math.round(value * 100) / 100;
}
